import classNames from 'classnames';
import Link from '../../../components/Link';
import PillBox from '../../../components/PillBox';
import { getWithCount } from '../../../services/Pluralize';
import styles from './style.m.less';

export function PureNavLink({
    title,
    route,
    routeSearchParams,
    icon,
    isCurrent,
    isDeactivated,
    notification,
    linkClass,
    titleClass,
    trackingLabel,
    testId,
    statusLabel,
    dataIntercomTarget,
    onClick,
    openInNewTab = false,
}) {
    const searchParams = routeSearchParams ? '?' + new URLSearchParams(routeSearchParams).toString() : '';
    const areNotificationsShown = notification && notification.count > 0;
    return (
        <li className={styles.liReset}>
            <Link
                href={route + searchParams}
                hasTextStyle={false}
                eventTracking={{ category: 'navigation sidebar', action: 'click', label: trackingLabel }}
                data-intercom-target={dataIntercomTarget}
                onClick={onClick}
                openInNewTab={openInNewTab}
                testId={testId}
            >
                <div className={classNames(styles.link, linkClass, { [styles.active]: isCurrent })}>
                    <span className={classNames(styles.icon, { [styles.deactivated]: isDeactivated })}>{icon}</span>
                    <span className={classNames(titleClass, styles.title, { [styles.deactivated]: isDeactivated })}>
                        {title}
                        {areNotificationsShown && (
                            <span
                                className={styles.notification}
                                aria-label={getWithCount('notification', notification.count)}
                            >
                                <PillBox color={notification.color} value={notification.count} />
                            </span>
                        )}
                    </span>
                    {statusLabel && <PillBox color={'YELLOW'} value={statusLabel} />}
                </div>
            </Link>
        </li>
    );
}
